import { Injectable } from '@angular/core';
import { Configuration, OpenAIApi } from 'openai';
import { AuthService } from '@service/auth.service';
import { UsersService } from '@service/users.service';

@Injectable({
  providedIn: 'root'
})
export class MentorService {
  countWords: number;
  currentWords: number;
  maxWords: number;

  public suggestions: string;
  public splitedSuggestions = [];
  public selectedSuggestion: string;

  public paraphrasedParagraph: string;

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
  ) { }

  public async callOpenAi(
      question: string,
      query: string,
      model: string,
      tokens: number,
      type: string,
      upperCase: boolean,
      temperature?: number,
      top_p?: number,
      frequency_penalty?: number,
      presence_penalty?: number,
      best_of?: number,
    ): Promise<any> {
    this.usersService.getWordsCount(this.authService.user.id).subscribe((res) => this.currentWords = res.words);
    const configuration = new Configuration({
      apiKey: "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",
    });
    const openai = new OpenAIApi(configuration);

    const completions = await openai.createCompletion({
      model: model,
      prompt: `${question}${query}\n`,
      max_tokens: tokens,
      temperature: temperature,
      top_p: top_p,
      frequency_penalty: frequency_penalty,
      presence_penalty: presence_penalty,
      best_of: best_of,
    });

    console.log(`${question}${query}\n`);

    if(type === "list") {
      this.suggestions = completions.data.choices[0].text;

      this.countWords = completions.data.choices[0].text.split(" ").length;

      // this.splitedSuggestions = this.suggestions.split("\n");
      this.splitedSuggestions = this.suggestions.split(/[(?<!^)"(?!$)]|["]?[\.]?[ ]?[\r\n|\r|\n]*[0-9]?[\.|\)|\-][0-9]? ["]?/g);

      if(upperCase) {
        for(let c = 0; c < this.splitedSuggestions.length; c++) {
          this.splitedSuggestions[c] = this.splitedSuggestions[c].toUpperCase();
        }
      }

      this.countWords += this.currentWords;
      this.usersService.updateWordsCount(this.authService.user.id, this.countWords)
        .subscribe(() => {
          this.authService.user.words_count = this.countWords;
        });

      return this.splitedSuggestions;
    } else if (type === "paragraph") {
      this.paraphrasedParagraph = completions.data.choices[0].text;

      // ! refactor this later, code repetition
      this.countWords = completions.data.choices[0].text.split(" ").length;

      this.countWords += this.currentWords;

      this.usersService.updateWordsCount(this.authService.user.id, this.countWords)
        .subscribe(() => {
          this.authService.user.words_count = this.countWords;
        });

      console.log(this.paraphrasedParagraph);
      return this.paraphrasedParagraph;
    }
  }
}
